const validate = (values) => {
  const errors = {};
  if (!values.recipients) {
    errors.recipients = 'Esse campo não pode ficar vazio';
  }
  if (values.planHeader) {
    errors.planHeader = {};
    if (!values.planHeader.subject) {
      errors.planHeader.subject = 'Esse campo não pode ficar vazio';
    }
    if (!values.planHeader.theme) {
      errors.planHeader.theme = 'Esse campo não pode ficar vazio';
    }
    if (!values.planHeader.generalObjective) {
      errors.planHeader.generalObjective = 'Esse campo não pode ficar vazio';
    }
    if (!values.planHeader.contents) {
      errors.planHeader.contents = 'Esse campo não pode ficar vazio';
    }
    if (!values.planHeader.procedureTaken) {
      errors.planHeader.procedureTaken = 'Esse campo não pode ficar vazio';
    }
    if (!values.planHeader.resources) {
      errors.planHeader.resources = 'Esse campo não pode ficar vazio';
    }
    if (!values.planHeader.evaluation) {
      errors.planHeader.evaluation = 'Esse campo não pode ficar vazio';
    }
    if (!values.planHeader.bnccSkills) {
      errors.planHeader.bnccSkills = 'Esse campo não pode ficar vazio';
    }
    if (!values.planHeader.generalObservation) {
      errors.planHeader.generalObservation = 'Esse campo não pode ficar vazio';
    }
  }
  if (values.planHeader && values.planHeader.rangeDate) {
    if (
      !values.planHeader.rangeDate.startDate ||
      !values.planHeader.rangeDate.endDate
    ) {
      errors.rangeDate = 'Informe o intervalo';
    }
  }
  return errors;
};

export default validate;
